import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRightIcon, BarChart3Icon, UsersIcon, LightbulbIcon } from 'lucide-react';
interface InstructionSlideProps {
  onContinue: () => void;
}
const features = [{
  icon: BarChart3Icon,
  title: 'Spot the gaps',
  description: 'See where specialists differ the most across key clinical decisions.',
  color: 'bg-rose-50 text-rose-600'
}, {
  icon: UsersIcon,
  title: 'Find your tribe',
  description: 'Discover who thinks like you — across all specialties.',
  color: 'bg-indigo-50 text-indigo-600'
}, {
  icon: LightbulbIcon,
  title: 'Understand why',
  description: 'Explore what drives these differences in real-world practice.',
  color: 'bg-amber-50 text-amber-600'
}];
export function InstructionSlide({
  onContinue
}: InstructionSlideProps) {
  return <div className="w-full min-h-screen flex items-center justify-center bg-[#FAFAF8] px-6" data-id="element-107">
      <div className="max-w-lg w-full space-y-10" data-id="element-108">
        <motion.div initial={{
        opacity: 0,
        y: 15
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.4
      }} className="space-y-2" data-id="element-109">
          <h2 className="text-2xl md:text-3xl font-bold text-[#1C1917]" data-id="element-110">
            How to explore the differences
          </h2>
          <p className="text-[#57534E]" data-id="element-111">
            Each answer reveals how your peers think — and why.
          </p>
        </motion.div>

        <div className="space-y-4" data-id="element-112">
          {features.map((feature, index) => {
          const Icon = feature.icon;
          const [bgClass, textClass] = feature.color.split(' ');
          return <motion.div key={index} initial={{
            opacity: 0,
            y: 15
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.4,
            delay: 0.1 * index
          }} className="flex items-start gap-4 bg-white rounded-2xl p-5 shadow-sm border border-neutral-100" data-id="element-113">
                <div className={`flex-shrink-0 w-10 h-10 rounded-xl ${bgClass} flex items-center justify-center`} data-id="element-114">
                  <Icon className={`w-5 h-5 ${textClass}`} data-id="element-115" />
                </div>
                <div className="flex-1" data-id="element-116">
                  <h3 className="text-base font-bold text-[#1C1917] mb-0.5" data-id="element-117">
                    {feature.title}
                  </h3>
                  <p className="text-sm text-[#57534E] leading-relaxed" data-id="element-118">
                    {feature.description}
                  </p>
                </div>
              </motion.div>;
        })}
        </div>

        <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} transition={{
        delay: 0.5
      }} className="flex justify-center pt-2" data-id="element-119">
          <button onClick={onContinue} className="inline-flex items-center gap-2 px-10 py-4 bg-[#1C1917] text-white text-lg font-bold rounded-xl hover:bg-neutral-800 transition-all shadow-lg hover:-translate-y-0.5" data-id="element-120">
            Start
            <ArrowRightIcon className="w-5 h-5" data-id="element-121" />
          </button>
        </motion.div>
      </div>
    </div>;
}